(function () {
  'use strict';

  var PE_VENDORS = [
    'K9 Natural',
    'Feline Natural',
    'Zignature',
    'Fussie Cat',
    'Canine Caviar',
    'Papa Bow Wow',
    'Real Meat',
    'Inception',
    "Poppy's Naturally Clean"
  ];

  function isPetExpress(vendor) {
    return PE_VENDORS.indexOf(vendor) !== -1;
  }

  function showBanner(addingIsPE) {
    var existing = document.getElementById('pe-cart-conflict');
    if (existing) existing.remove();
    var msg = addingIsPE
      ? 'Pet Express items must be ordered separately from CPG Reps items. Please complete or empty your current cart first.'
      : 'CPG Reps items cannot be combined with Pet Express items. Please complete or empty your current cart first.';
    var el = document.createElement('div');
    el.id = 'pe-cart-conflict';
    el.style.cssText = [
      'position:fixed','top:20px','left:50%','transform:translateX(-50%)',
      'background:#b91c1c','color:#fff','padding:16px 24px','border-radius:8px',
      'z-index:99999','font-size:14px','max-width:480px','width:calc(100% - 40px)',
      'text-align:center','box-shadow:0 4px 20px rgba(0,0,0,0.3)','line-height:1.6','cursor:pointer'
    ].join(';');
    el.textContent = msg;
    el.addEventListener('click', function () { el.remove(); });
    document.body.appendChild(el);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 8000);
  }

  var pendingVendor = null;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.getAttribute('data-type') === 'add-to-cart-form') {
      var pf = form.closest('product-form');
      if (pf && pf.dataset.vendor) { pendingVendor = pf.dataset.vendor; }
    }
  }, true);

  var _fetch = window.fetch;
  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      var vendor = pendingVendor;
      pendingVendor = null;
      if (vendor) {
        return _fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var addingIsPE = isPetExpress(vendor);
            var cartHasPE  = cart.items.some(function (i) { return isPetExpress(i.vendor); });
            var cartHasCPG = cart.items.some(function (i) { return !isPetExpress(i.vendor); });
            if ((addingIsPE && cartHasCPG) || (!addingIsPE && cartHasPE)) {
              showBanner(addingIsPE);
              var errMsg = addingIsPE
                ? 'Pet Express orders must be placed separately from CPG Reps orders.'
                : 'CPG Reps orders must be placed separately from Pet Express orders.';
              return new Response(
                JSON.stringify({ status: 422, message: errMsg, errors: errMsg }),
                { status: 422, headers: { 'Content-Type': 'application/json' } }
              );
            }
            return _fetch.call(window, resource, options);
          })
          .catch(function () { return _fetch.call(window, resource, options); });
      }
    }
    return _fetch.call(window, resource, options);
  };
})();
